export default __webpack_public_path__ + "media/images/background-waves-9678c9daa18bddd9d810459deb2e3b1f.png";